import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { useAuthStore } from './stores';
import { authApi } from './services/api';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Templates from './pages/Templates';
import TemplateBuilder from './pages/TemplateBuilder';
import Inspections from './pages/Inspections';
import InspectionForm from './pages/InspectionForm';
import Tasks from './pages/Tasks';
import Reports from './pages/Reports';
import Analytics from './pages/Analytics';
import Layout from './components/Layout';

function App() {
  const { isAuthenticated, isLoading, setAuth, logout } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    // Only check token once on initial load
    const token = localStorage.getItem('token');
    if (token && !isAuthenticated && isLoading) {
      authApi.me()
        .then((response) => {
          const data = response.data || response;
          setAuth(data.user, token);
        })
        .catch(() => {
          logout();
          navigate('/login');
        });
    } else if (!token) {
      useAuthStore.getState().setLoading(false);
    }
  }, []); // Empty dependency array - only run once on mount

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={
        isAuthenticated ? <Navigate to="/" /> : <Login />
      } />
      <Route path="/register" element={
        isAuthenticated ? <Navigate to="/" /> : <Register />
      } />
      
      <Route path="/" element={
        isAuthenticated ? <Layout /> : <Navigate to="/login" />
      }>
        <Route index element={<Dashboard />} />
        <Route path="templates" element={<Templates />} />
        <Route path="templates/new" element={<TemplateBuilder />} />
        <Route path="templates/:id/edit" element={<TemplateBuilder />} />
        <Route path="inspections" element={<Inspections />} />
        <Route path="inspections/new" element={<InspectionForm />} />
        <Route path="inspections/:id" element={<InspectionForm />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="reports" element={<Reports />} />
        <Route path="analytics" element={<Analytics />} />
      </Route>
    </Routes>
  );
}

export default App;